import { useEffect, useRef, useState } from "react";

// Pulls down from the very top of the page to trigger a refresh (touch only).
export function usePullToRefresh(onRefresh, enabled = true, threshold = 70) {
  const [pull, setPull] = useState(0);
  const pullRef = useRef(0);
  const startRef = useRef(null);
  const setP = (v) => { pullRef.current = v; setPull(v); };

  useEffect(() => {
    if (!enabled) return undefined;
    const onStart = (e) => {
      startRef.current = window.scrollY <= 0 && e.touches.length === 1 ? e.touches[0].clientY : null;
    };
    const onMove = (e) => {
      if (startRef.current == null) return;
      const dy = e.touches[0].clientY - startRef.current;
      if (dy > 0 && window.scrollY <= 0) setP(Math.min(dy * 0.5, threshold + 30));
      else if (dy <= 0) setP(0);
    };
    const onEnd = () => {
      if (pullRef.current >= threshold) onRefresh();
      startRef.current = null;
      setP(0);
    };
    document.addEventListener("touchstart", onStart, { passive: true });
    document.addEventListener("touchmove", onMove, { passive: true });
    document.addEventListener("touchend", onEnd);
    return () => {
      document.removeEventListener("touchstart", onStart);
      document.removeEventListener("touchmove", onMove);
      document.removeEventListener("touchend", onEnd);
    };
  }, [enabled, onRefresh, threshold]);

  return pull;
}
